export default __webpack_public_path__ + "static/media/miguel-lopes-37.f1a2e834.jpg";